import api from '@/api'
import vuex from '@/store'

export default {
  state: {
    areOptionsLoaded: false,
    areTagsLoaded: false,
    storyTags: [],
    videoTags: [],
    publishedStoryTags: [],
    publishedVideoTags: [],
    employees: [],
    extraContacts: [],
    format: [],
    platforms: [],
    region: [],
    status: [],
    source: [],
    storyApproved: [{ value: 'Approved' }, { value: 'Unapproved' }, { value: 'Bust' }],
    storyType: [],
    liveType: [],
    liveSource: [],
    notificationGroupsList: [],
    inventoryStatusOptions: [
      { value: 'available', label: 'Available' },
      { value: 'unavailable', label: 'Unavailable' }
    ],
    aiProviderStatusOptions: [
      { value: 1, label: 'Active' },
      { value: 0, label: 'Inactive' }
    ]
  },
  mutations: {
    LOAD_OPTION_TYPE(state, { type, data }) {
      state[type] = data
    },
    CLEAR_ALL_OPTIONS(state) {
      console.debug('CLEARING ALL OPTIONS')
      state.storyTags = []
      state.publishedStoryTags = []
      state.videoTags = []
      state.publishedVideoTags = []
      state.employees = []
      state.format = []
      state.platforms = []
      state.region = []
      state.status = []
      state.storyType = []
      state.liveType = []
      state.liveSource = []
      state.notificationGroupsList = []
      state.areOptionsLoaded = false
      state.areTagsLoaded = false
    },

    UPSERT_EMPLOYEE(state, data) {
      let idx = state.employees.findIndex((emp) => emp.value == data.value)
      if (idx < 0) {
        state.employees.push(data)
      } else {
        // use vue set so its reactive
        state.employees[idx] = Object.assign(state.employees[idx], data)
      }
    },
    DELETE_EMPLOYEE(state, id) {
      let idx = state.employees.findIndex((emp) => emp.value == id)
      if (idx >= 0) {
        state.employees.splice(idx, 1)
      }
    },
    UPSERT_EXTRA_CONTACT(state, data) {
      let idx = state.extraContacts.findIndex((emp) => emp.value == data.value)
      if (idx < 0) {
        state.extraContacts.push(data)
      } else {
        // use vue set so its reactive
        state.extraContacts[idx] = Object.assign(state.extraContacts[idx], data)
      }
    },
    DELETE_EXTRA_CONTACT(state, id) {
      let idx = state.extraContacts.findIndex((emp) => emp.value == id)
      if (idx >= 0) {
        state.extraContacts.splice(idx, 1)
      }
    }
  },
  actions: {
    async loadOptionType({ commit, state, dispatch }, { type, skipCache = false } = {}) {
      // get list of stories from API
      const _o = await api.newsdesk.getColumnOptions(type, skipCache)
      let requests = _o?.data ?? []

      commit('LOAD_OPTION_TYPE', { type, data: requests })
    },
    async loadTags({ commit, state, dispatch }, { skipCache = false } = {}) {
      const _o = await api.newsdesk.getTags(skipCache)
      let options = _o?.data ?? []

      commit('LOAD_OPTION_TYPE', { type: 'storyTags', data: options.filter((o) => o.type == 'story') })
      commit('LOAD_OPTION_TYPE', { type: 'publishedStoryTags', data: options.filter((o) => o.type == 'story' && o.is_published === true) })
      commit('LOAD_OPTION_TYPE', { type: 'videoTags', data: options.filter((o) => o.type == 'video') })
      commit('LOAD_OPTION_TYPE', { type: 'publishedVideoTags', data: options.filter((o) => o.type == 'video' && o.is_published === true) })
      state.areTagsLoaded = true
    },

    addTag({ commit, state, dispatch }, { type, data, station, skipCache = true }) {
      console.debug('Adding tag', type, data, station)
      return dispatch('updateTag', { type, data, station, skipCache })
    },
    async updateTag({ commit, state, dispatch }, { type, data, station, skipCache = true }) {
      await api.newsdesk.saveTag(type, data, station)
      return await dispatch('loadTags', { skipCache })
    },
    async deleteTag({ commit, state, dispatch }, { type, id, station, skipCache = true }) {
      await api.newsdesk.deleteTag(type, id, station)
      return await dispatch('loadTags', { skipCache })
    },
    async loadAllOptionTypes({ commit, state, dispatch }, { skipCache = false } = {}) {
      const _o = await api.newsdesk.getAllColumnOptions(skipCache)
      let options = _o?.data ?? []

      commit('LOAD_OPTION_TYPE', { type: 'storyType', data: options.filter((o) => o.column == 'storyType') })
      commit('LOAD_OPTION_TYPE', { type: 'format', data: options.filter((o) => o.column == 'format') })
      commit('LOAD_OPTION_TYPE', { type: 'platforms', data: options.filter((o) => o.column == 'platforms') })
      commit('LOAD_OPTION_TYPE', { type: 'region', data: options.filter((o) => o.column == 'region') })
      commit('LOAD_OPTION_TYPE', { type: 'status', data: options.filter((o) => o.column == 'status') })
      commit('LOAD_OPTION_TYPE', { type: 'liveType', data: options.filter((o) => o.column == 'liveType') })
      commit('LOAD_OPTION_TYPE', { type: 'liveSource', data: options.filter((o) => o.column == 'liveSource') })
      commit('LOAD_OPTION_TYPE', { type: 'source', data: options.filter((o) => o.column == 'source') })
      state.areOptionsLoaded = true
    },
    async loadEmployees({ commit, state, dispatch }, { skipCache = false } = {}) {
      let employees = []

      try {
        const response = await api.newsdesk.getNewsDeskUsers()
        const empData = response.data?.map((emp) => ({ value: emp.id, label: emp.name.trim(), emp })) ?? []
        employees = empData
      } catch (error) {
        console.error('loadEmployees(): could not employees data', error)
      }

      // load extra contacts as well (users with no empid that have station_id set to current station's id)
      try {
        const response = await api.newsdesk.getExtraContacts()
        const contactData = response.data?.map((ndUser) => ({ value: ndUser.id, label: ndUser.name.trim(), emp: ndUser })) ?? []
        employees = employees.concat(contactData)
      } catch (error) {
        console.error('loadEmployees(): could not load extra contacts data', error)
      }

      // Commit any employees we did successfully load
      if (employees.length > 0) {
        commit('LOAD_OPTION_TYPE', { type: 'employees', data: employees })
      }
    },

    async loadExtraContacts({ commit, state, dispatch }, { skipCache = false } = {}) {
      const _o = await api.newsdesk.getExtraContacts()
      let contacts = _o?.data ?? []

      let extraContacts = contacts.map((ndUser) => ({ value: ndUser.id, label: ndUser.name.trim(), emp: ndUser }))
      commit('LOAD_OPTION_TYPE', { type: 'extraContacts', data: extraContacts })
    },

    async addExtraContact({ commit, state, dispatch }, { name, email }) {
      const _s = await api.newsdesk.addExtraContact({ name, email })
      const contact = _s.data
      commit('UPSERT_EXTRA_CONTACT', { value: contact.id, label: contact.name.trim(), emp: contact })
    },

    async updateExtraContact({ commit, state, dispatch }, { id, name, email, newStation }) {
      const _s = await api.newsdesk.saveExtraContact({ id, name, email, newStation })
      const contact = _s.data
      commit('UPSERT_EXTRA_CONTACT', { value: contact.id, label: contact.name.trim(), emp: contact })
    },

    async deleteExtraContact({ commit, state, dispatch }, id) {
      await api.newsdesk.deleteExtraContact(id)
      commit('DELETE_EXTRA_CONTACT', id)
    },

    async addOptionType({ commit, state, dispatch }, { type, data, station, skipCache = true }) {
      const _s = await api.newsdesk.saveColumnOption(type, data, station)
      await dispatch('loadOptionType', { type, skipCache })
    },

    async updateOptionType({ commit, state, dispatch }, { type, data, station, skipCache = true }) {
      const _s = await api.newsdesk.saveColumnOption(type, data, station)
      await dispatch('loadOptionType', { type, skipCache })
    },

    async deleteOptionType({ commit, state, dispatch }, { type, id, station, skipCache = true }) {
      await api.newsdesk.deleteColumnOption(type, id, station)
      await dispatch('loadOptionType', { type, skipCache })
    },
    async loadNotificationGroupsList({ commit, state, dispatch }) {
      // get list of stories from API
      const _o = await api.newsdesk.getNotificationGroupsList()
      let requests = _o?.data ?? []

      commit('LOAD_OPTION_TYPE', { type: 'notificationGroupsList', data: requests })
    }
  },
  getters: {
    areOptionsLoaded(state) {
      return state.areOptionsLoaded
    },
    areTagsLoaded(state) {
      return state.areTagsLoaded
    },
    storyTags(state) {
      return state.storyTags
    },
    publishedStoryTags(state) {
      return state.publishedStoryTags
    },
    videoTags(state) {
      return state.videoTags
    },
    publishedVideoTags(state) {
      return state.publishedVideoTags
    },
    storyType(state) {
      return state.storyType
    },
    daypartOptions(state) {
      return state.storyType
    },
    employees(state) {
      return [...state.extraContacts, ...state.employees]
    },
    extraContacts(state) {
      return state.extraContacts
    },
    format(state) {
      return state.format
    },
    platforms(state) {
      return state.platforms
    },
    region(state) {
      return state.region
    },
    status(state) {
      return state.status
    },
    source(state) {
      return state.source
    },
    storyApproved(state) {
      return state.storyApproved
    },
    liveType(state) {
      return state.liveType
    },
    liveSource(state) {
      return state.liveSource
    },
    notificationGroupsList(state) {
      return state.notificationGroupsList
    },
    inventoryStatusOptions(state) {
      return state.inventoryStatusOptions
    },
    aiProviderStatusOptions(state) {
      return state.aiProviderStatusOptions
    }
  }
}
